export class SearchRequest {
    private filterArray: string[];
    private brandFilter?: string[];

    constructor(search: string) {
        this.search = search;
        this.count = true;
        this.filterArray = [];
        this.facets = [];
        //this.select = "jobId,title,description,tasks,profile,keyWords,jobType,jobTypes,jobLevel,jobLevels,jobSector,jobSectors,jobFunction,jobFunctions,location,datePosted,hiringOrganisation/name,startDate,template,validThrough";
    }

    count: boolean;
    facets?: string[];
    filter?: string;
    orderby?: string;
    search: string;
    searchFields?: string;
    select?: string;
    skip?: number;
    top?: number;

    highlight?: string;
    highlightPreTag?: string;
    highlightPostTag?: string;
    searchMode?: string;
    queryType?: string;
    minimumCoverage?: number;
    scoringParameters?: string;
    scoringProfile?: string;

    addFilter(filter: string) {
        this.filterArray.push(filter);
    }
    setBrandFilter(brands: string[]) {
        this.brandFilter = brands.map(brand => `brand eq '${brand}'`);
    }
    setDatePostedFilter() {
        let date = new Date();
        this.filterArray.push('datePosted lt ' + date.toISOString());
    }
    setJobIdsFilter(jobIds: string[]) {
        this.filterArray.push(`search.in(jobId, '${jobIds.join(',')}')`);
    }
    toRequest() {
        return {
            count: this.count,
            facets: this.facets,
            filter: this.filterArray.join(' and ') + (this.brandFilter && this.brandFilter.length ? ' and (' + this.brandFilter.join(' or ') + ')' : ''),
            orderby: this.orderby,
            search: this.search,
            queryType: this.queryType,
            searchFields: this.searchFields,
            select: this.select,
            skip: this.skip,
            top: this.top
        }
    }
}
